export default __webpack_public_path__ + "43c92e1ebe0e03e55d646b962fbc51d4.svg";